import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'

import { Button } from 'react-toolbox/lib/button'

import styles from './styles.scss'

const LoginButton = ({ label, onClick }) => (
  <Flex
    styleName='buttonContainer'
    justify='flex-end'
  >
    <Button
      theme={styles}
      label={label}
      onClick={onClick}
      raised
      primary
    />
  </Flex>
)

LoginButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

LoginButton.defaultProps = {
  label: '',
}

const withStyle = CSSModules(styles)
export default withStyle(LoginButton)
